import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { BodyText, DisplayText, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ReorderRailHeading = () => {
  const { minWidth } = useResponsive();

  // ─────────────────────────────────────────────────────────────────────

  if (minWidth.isSM) {
    return (
      <DisplayText sizeMatch={['32']}>
        <FormattedMessage {...messages.heading} />
      </DisplayText>
    );
  }

  return (
    <BodyText sizeMatch={['18']}>
      <FormattedMessage {...messages.heading} />
    </BodyText>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  heading: {
    defaultMessage: 'Order again',
    description: 'Menu | Reorder rail | Heading',
  },
});
